import { BaseParameterDto } from './base-parameter-dto';

export class ValidateUserInfoParameterDto extends BaseParameterDto {
  email: string;
  userName: string;
  guid: string;
}
